import api from './api';
import { ApiResponse, MargemRelatorio, OrientacaoRelatorio } from '../types';

export const margemRelatorioService = {
  listar: async (): Promise<MargemRelatorio[]> => {
    const response = await api.get<MargemRelatorio[]>('/margens');
    return response.data;
  },

  buscarPorOrientacao: async (orientacao: OrientacaoRelatorio): Promise<MargemRelatorio> => {
    const response = await api.get<MargemRelatorio>(`/margens/${orientacao}`);
    return response.data;
  },

  salvar: async (margens: MargemRelatorio[]): Promise<ApiResponse<MargemRelatorio[]>> => {
    const response = await api.put<ApiResponse<MargemRelatorio[]>>('/margens', { margens });
    return response.data;
  },

  restaurarPadrao: async (orientacao: OrientacaoRelatorio): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/margens/${orientacao}`);
    return response.data;
  },
};
